import { IconButton, Typography } from '@mui/material';
import EventIcon from '@mui/icons-material/Event'; // Example calendar icon
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ModuleItemBox } from '../FolderModule.styles';
import { useNavigate } from 'react-router-dom';
import { theme } from '../../../../theme';
import { useLocale } from '../../../../hooks/UseLocale';

type Props = {
    id: number;
    name: string;
    colorHex: string;
    onDelete: () => void;
    onEdit: () => void;
};

const CalendarCard = ({ id, name, colorHex, onDelete, onEdit }: Props) => {
    const navigate = useNavigate();
    const locale = useLocale();

    const handleModuleClick = () => {
        navigate(`/${locale}/servicemodules/calendar/${id}`);
    };

    const handleEditClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        onEdit();
    };

    const handleDeleteClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        onDelete();
    };

    return (
        <ModuleItemBox onClick={handleModuleClick}>
            <EventIcon htmlColor={colorHex ? colorHex : theme.palette.primary.main} />
            <Typography sx={{ flexGrow: 1, marginLeft: 2 }}>{name}</Typography>
            <IconButton onClick={handleEditClick}>
                <EditIcon />
            </IconButton>
            <IconButton onClick={handleDeleteClick}>
                <DeleteIcon />
            </IconButton>
        </ModuleItemBox>
    );
};

export default CalendarCard;